import { BlogEventCard } from "@/components/common/cards/BlogEventsCard";
import { eventsData } from "@/data/events";

export const ComingEvents = () => {
  const upcomingEvents = eventsData.filter((event) => {
    const eventDate = new Date(event.date);
    const today = new Date();
    return eventDate > today;
  });

  return (
    <section className="flex flex-col gap-12">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {upcomingEvents.map((event) => (
          <BlogEventCard
            key={event.id}
            {...event}
            variant="secondary"
            type="Event"
            location={event.location}
          />
        ))}
      </div>
    </section>
  );
};
